import { render, staticRenderFns } from "./HRIndustry.vue?vue&type=template&id=c473df92"
import script from "./HRIndustry.vue?vue&type=script&lang=js"
export * from "./HRIndustry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports